import React from 'react'
import './Error404.scss'

const Error404 = () => {
  return (
    <div className='scope-error404 with-menu-bar'>
      404 - You've ventured into the void
    </div>
  )
}

export default Error404
